<template>
    <section id="external-activity-container" :class="{'cloaked' : isTransitioning}" style="min-height: 100vh">
        <Modal :moveForward="moveForward" :attemptedContent="attemptedContent"/>

        <Header :selectedLanguage="selectedLanguage" :moveBack="moveBack" :selectedParent="selectedParent" :activity="activity" :resetLanguage="resetLanguage"/>
        <h3 v-if="(activity.logo == null || activity.logo == '') && !selectedParent && !isShop" class="external-activity--name">{{ activity.name }}</h3>
        <HeaderShop
            v-if="authed && localUser && (Object.keys(localUser).length || isShop) && selectedLanguage"
            :localUser="localUser"
            :isShop="isShop && !selectedParent"
            :parentLabel="selectedParent ? findValueFromCode(selectedParent, 'title', selectedLanguage, defaultLanguage, false) : (isShop ? activity.name : null)
        "/>

        <LanguageSelector
            :languages="languages"
            :activity="activity"
            :selectLanguage="selectLanguage"
             v-if="!selectedLanguage && defaultCartLanguage"
        />
        <template v-else>
            <template v-if="authed">
                <template>
                    <Single v-if="isFinal"
                        :isFinal="isFinal"
                        :activity="activity"
                        :parent="selectedParent"
                        :language="selectedLanguage"
                        :defaultCartLanguage="defaultCartLanguage"
                        :defaultLanguage="defaultLanguage"
                        :nl2br="nl2br"
                        :displayableContent="displayableContent"
                        :identifyLink="identifyLink"
                        :findValueFromCode="findValueFromCode"
                    />
                    <template v-else>
                        <div v-for="(contentItem, index) in displayableContent" v-if="contentItem.active">
                            <Card
                                :activity="activity"
                                :defaultCartLanguage="defaultCartLanguage"
                                :contentItem="contentItem"
                                :moveForward="moveForward"
                                :findValueFromCode="findValueFromCode"
                                :language="selectedLanguage"
                                :defaultLanguage="defaultLanguage"
                            />
                        </div>
                    </template>
                </template>
            </template>
            <PinAuth v-else :activity="activity" :user="localUser"/>
        </template>
        <div style="display: flex;justify-content: center;" v-if="Object.keys(localUser ? localUser : {}).length">
            <a href="#" @click.prevent="attemptLogout">Logout</a>
        </div>
        <CartBar v-if="(canOrder | isShop) && authed && selectedLanguage && !previewableCartItem && !showCart"/>
        <transition name="slide-up">
            <Cart
                v-if="(canOrder | isShop) && authed && selectedLanguage && showCart"
                :findValueFromCode="findValueFromCode"
                :language="selectedLanguage"
                :isShop="isShop"
                :charges="activity.charges_for_service"
                :defaultLanguage="defaultLanguage"
            />
        </transition>
        <transition name="slide-up">
            <CartItem
                v-if="previewableCartItem && (canOrder | isShop)"
                :findValueFromCode="findValueFromCode"
                :language="selectedLanguage"
                :defaultLanguage="defaultLanguage"
            />
        </transition>
        <transition name="slide-up">
            <CartDeliveryDetails
                v-if="showDeliveryDetails && (canOrder | isShop)"
                :findValueFromCode="findValueFromCode"
                :language="selectedLanguage"
                :charges="activity.charges_for_service"
                :isShop="isShop"
                :defaultLanguage="defaultLanguage"
            />
        </transition>
        <CartSuccess v-if="showOrderConfirmation"/>
        <CartFinal v-if="showOrderEmailConfirmation"/>
        <FooterText :activity="activity"/>
        <FooterSocials :activity="activity"/>
    </section>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import FooterText from './Parts/FooterText'
    import FooterSocials from './Parts/FooterSocials'
    import LanguageSelector from './Parts/LanguageSelector'
    import PinAuth from './Parts/PinAuth'
    import Header from './Parts/Header'
    import HeaderShop from './Parts/HeaderShop'

    import Single from './Products/Single'
    import Card from './Products/Card'
    import Tags from './Products/Tags'

    import EventBus from '../EventBus'

    import Modal from './Modal'
    import CartBar from './CartBar'
    import Cart from './Cart'
    import CartDeliveryDetails from './CartDeliveryDetails'
    import CartItem from './CartItem'
    import CartSuccess from './CartSuccess'
    import CartFinal from './CartFinal'

    export default {
        props: [
            'languages',
            'defaultLanguage',

            'initialCartLanguages',
            'initialDefaultCartLanguage',

            'termsLink',
            'emailMandatoryOnOrder',
            'minimumOrder',


            'activity',
            'content',
            'user',
            'canOrder',
            'isShop',
        ],

        components: {
            FooterText,
            FooterSocials,
            LanguageSelector,
            Header,
            HeaderShop,
            Single,
            Card,
            Tags,
            PinAuth,
            Modal,
            CartBar,
            Cart,
            CartDeliveryDetails,
            CartItem,
            CartSuccess,
            CartFinal,
        },

        mounted () {
            this.hideOtherRestaurantModal()
            this.closeAllOverLays()
            if (this.languages.length === 1) {
                this.selectedLanguage = this.languages[0]
            } else {
                if(localStorage.getItem("language") === null){
                    this.selectedLanguage = null
                } else {
                    this.selectedLanguage = JSON.parse(localStorage.getItem("language"))
                    this.selectLanguage(this.selectedLanguage)
                }
            }

            this.setCartLanguages(this.initialCartLanguages)

            if(!this.defaultCartLanguage) {
                this.setDefaultCartLanguage(this.initialDefaultCartLanguage)
            }

            if(this.activityUuid !== this.activity.uuid) {
                this.emptyCart()
                this.closeAllOverLays()
            }
            this.setActivityUuid(this.activity.uuid)
            this.setTermsLink(this.termsLink)
            this.setEmailMandatoryOnOrder(this.emailMandatoryOnOrder)
            this.setMinimumOrder(this.minimumOrder)

            EventBus.$on('login', (payload) => {
                this.localUser = payload.user
            })
        },

        methods: {
            ...mapActions([
                'setActivityUuid',
                'setTermsLink',
                'setEmailMandatoryOnOrder',
                'setMinimumOrder',
                'setDefaultCartLanguage',
                'setDefaultCartLanguageCode',
                'setCartLanguages',
                'showOtherRestaurantModal',
                'hideOtherRestaurantModal',
                'closeAllOverLays',
                'emptyCart'
            ]),

            findValueFromCode(on, prop, search, fallback, doNewLine) {
                let found = null

                if(search && on[prop][search['code']]){
                    found = on[prop][search['code']]
                } else {
                    found = on[prop][fallback['code']]
                }


                if(doNewLine){
                    return this.nl2br(found)
                }

                return found
            },

            nl2br(text) {
                if(text != undefined) {
                    return text.replace(/(?:\r\n|\r|\n)/g, '<br />')
                } else {
                    return undefined
                }
            },

            selectLanguage(language) {
                this.selectedLanguage = language
                localStorage.setItem("language", JSON.stringify(language))
                if(Object.keys(this.cartLanguages).indexOf(this.selectedLanguage.code) !== -1){
                    this.setDefaultCartLanguage(this.cartLanguages[this.selectedLanguage.code])
                } else {
                    this.setDefaultCartLanguage(this.initialDefaultCartLanguage)
                }
                this.setDefaultCartLanguageCode(this.selectedLanguage.code)
            },

            resetLanguage(language) {
                this.selectedLanguage = null
                localStorage.removeItem("language")
                this.setDefaultCartLanguage(this.initialDefaultCartLanguage)
            },

            identifyLink(content) {
                if(content.external_url[this.selectedLanguage.code] && content.external_url[this.selectedLanguage.code].length > 2){
                    return content.external_url[this.selectedLanguage.code]
                } else if(content.external_url[this.defaultLanguage.code] && content.external_url[this.defaultLanguage.code].length > 2){
                    return content.external_url[this.defaultLanguage.code]
                }

                return false;
            },

            moveForward(content) {
                let _this = this

                if(content.restaurant && !content.restaurant.opening_status.open) {
                    return false
                }

                if(content.restaurant && _this.cartRestaurant && _this.cartRestaurant.uuid !== content.restaurant.uuid) {
                    _this.attemptedContent = content
                    _this.showOtherRestaurantModal()
                } else {
                    _this.attemptedContent = content
                    _this.isTransitioning = true
                    setTimeout(() => {
                        let link = _this.identifyLink(content)

                        if(link) {
                            window.open(link, '_blank');
                        } else {
                            if(!_this.isFinal) {
                                _this.previousParent = _this.selectedParent
                                _this.selectedParent = content
                                document.getElementById("app").scrollTo(0,0)
                            }
                        }
                        _this.isTransitioning = false
                    }, 200)
                }
            },

            moveBack () {
                let _this = this
                _this.isTransitioning = true

                setTimeout(() => {
                    if (_this.previousParent && _this.selectedParent.id == _this.previousParent.id) {
                        _this.selectedParent = null
                    } else {
                        _this.selectedParent = _this.previousParent
                    }
                    document.getElementById("app").scrollTo(0,0)
                    _this.isTransitioning = false
                }, 200)
            },

            attemptLogout () {
                this.logoutError = null;

                window.axios.post(`/${this.activity.uuid}/logout`, {}).then((response) => {
                    this.localUser = null
                    this.emptyCart()
                    EventBus.$emit('login', {
                        user: this.localUser
                    })
                }).catch((err) => {
                    console.log(err.response.data.result)
                    this.logoutError = "Accesso non valido"
                })
            },
        },

        computed: {
            ...mapGetters([
                'defaultCartLanguage',
                'showDeliveryDetails',
                'previewableCartItem',
                'showCart',
                'showOrderConfirmation',
                'showOrderEmailConfirmation',
                'cartLanguages',
                'cartRestaurant',
                'activityUuid',
                'isOtherRestaurantModalVisible'
            ]),
            authed () {
                if (this.canOrder && !Object.keys(this.localUser ? this.localUser : {}).length) {
                    return false;
                }

                return true;
            },

            isFinal () {
                return this.displayableContent.filter((content) => content.children.length > 0).length === 0
            },

            displayableContent () {
                return this.selectedParent ? this.selectedParent.children : this.content
            },
        },

        watch: {
            isOtherRestaurantModalVisible(newValue) {
                if(newValue) {
                    $('#otherRestaurant').modal('show')
                } else {
                    $('#otherRestaurant').modal('hide')
                }
            }
        },

        data () {
            return {
                localUser: this.user,
                showItem: null,
                parentLabel: null,

                isTransitioning: false,
                selectedParent: null,
                previousParent: null,
                selectedLanguage: null,

                attemptedContent: null,
                logoutError: null
            }
        }
    }
</script>
<style>
    #external-activity-container {
        opacity: 1;
        transition: opacity 200ms;
    }

    #external-activity-container.cloaked {
        opacity: 0;
    }

    div.vue-pincode-input-wrapper {
        width: 100%!important;
    }

    input.vue-pincode-input {
        max-width: 65px!important;
        height: 65px!important;
        font-size: 40px;
        margin-bottom: 20px;
        margin-top: 20px;
        border: 1px solid #f2f2f2!important;
    }

    .slide-up-enter-active {
      transition: all .2s ease;
    }
    .slide-up-leave-active {
      transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-up-enter, .slide-up-leave-to {
      transform: translateY(100vh);
      opacity: 0;
    }
</style>
